
import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css'; // PDF viewer stilini yükleme
import questionMark from "../../images/svg/question.svg";

// pdfjs-dist'i import edin
import * as pdfjsLib from 'pdfjs-dist';

const Container = styled.div`
  position: relative;
  width: 100%;
  height: calc(100% - 50px);
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .action-text {
    font-size: 1.5rem;
    font-weight: 500;
  }
`;

const ImageUploader = ({ previewSrc, onFileSelect, isPdf }) => {
  const [isHovered, setIsHovered] = useState(false);

  const onDrop = useCallback(
    (acceptedFiles) => {
      onFileSelect(acceptedFiles);
      // Burada previewSrc zaten URL olarak geliyor, dolayısıyla dosya URL'sini güncellemeye gerek yok
    },
    [onFileSelect]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/png': [],
      'image/jpg': [],
      'image/jpeg': [],
      'application/pdf': []
    }
  });

  return (
    <Container
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...getRootProps()}  // Tüm container dropzone olsun diye buraya ekledik.
      style={{ cursor: 'pointer' }}
    >
      <input {...getInputProps()} />

      {previewSrc === "question" || !previewSrc ? (
        // Hiç dosya seçilmediyse veya "question" ise soru işareti göster.
        <img
          src={questionMark}
          alt="Question Mark"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            zIndex: 1,
            pointerEvents: 'none'
          }}
        />
      ) : (
        <>
          {isPdf ? (
            // PDF dosyasını react-pdf-viewer ile göster
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
            >
              {/* pdf.worker.min.js dosyasının yolu */}
              <Worker workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.js`}>
                <Viewer fileUrl={previewSrc} />
              </Worker>
            </div>
          ) : (
            <div>
              {/* Arka plan resmi (cover, daha koyu) */}
              <img
                src={previewSrc}
                alt="background preview"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  opacity: 0.4,
                  filter: 'brightness(40%)',
                  pointerEvents: 'none'
                }}
              />
              {/* Ön plan resmi (contain) */}
              <img
                src={previewSrc}
                alt="foreground preview"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  zIndex: 1,
                  pointerEvents: 'none'
                }}
              />
            </div>
          )}
        </>
      )}

      {/* Sürükle bırak alanı (overlay) */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          color: '#fff',
          opacity: isDragActive || isHovered ? 1 : 0,
          transition: 'opacity 0.3s ease',
          zIndex: 2,
          pointerEvents: 'none'
        }}
      >
        {isDragActive ? (
          <p className="action-text">Dosyayı buraya bırak</p>
        ) : (
          <p className="action-text">Seç veya Sürükle</p>
        )}
      </div>
    </Container>
  );
};

export default ImageUploader;
